'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$56() {
  this.bEY = null;
  this.bEZ = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$56 as $c_Lpresto_TwoFactorAuthView$$anon$56 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$56.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$56;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$56() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$56 as $h_Lpresto_TwoFactorAuthView$$anon$56 };
$h_Lpresto_TwoFactorAuthView$$anon$56.prototype = $p;
$p.P = (function() {
  if ((!this.bEZ)) {
    this.bEY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bEZ = true;
  }
  return this.bEY;
});
var $d_Lpresto_TwoFactorAuthView$$anon$56 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$56, "presto.TwoFactorAuthView$$anon$56", ({
  ST: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$56 as $d_Lpresto_TwoFactorAuthView$$anon$56 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$56.js.map
